import React, { useState, useEffect } from "react";
import Logo from "../../../assets/images/logo.png";

import MoneyWaveIcon from "../../../assets/images/moneywave.svg";
import StarIcon from "../../../assets/images/star-icon.svg";
import DollarIcon from "../../../assets/images/dollar-icon.svg";

import "./index.css";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { SPORTS_CATEGORY, URL } from "../../../const/index.js";
import {
    NCAAFB_GROUP,
    NCAABB_GROUP,
    SOCCER_GROUP,
} from "../../../const/SPORT_GROUPS.js";

import moment from "moment";

import { SPORT_ADD } from "../../../store/actionTypes.js";
import Template from "../Template.js";
import { getRandomNumber } from "../../../func.js";
import CustomModal from "../../../components/Modal/modal";

const Sports = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [team1Idx, setTeam1Idx] = useState(-1);
    const [sportCategory, setSportCategory] = useState("NBA3");
    const [events, setEvents] = useState([]);
    const [playList, setPlayList] = useState({});

    const [event, setEvent] = useState(null);
    const [eventId, setEventId] = useState(-1);
    const [eventDate, setEventDate] = useState();
    const [groupId, setGroupId] = useState(-1);

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const [primaryColor, setPrimaryColor] = useState("#0d6efd");
    const [secondaryColor, setSecondaryColor] = useState("white");

    const { isDemo } = useSelector((state) => state.auth);

    /* Get Total Event */
    useEffect(() => {
        if (sportCategory) {
            let apiUrl = URL[sportCategory + "_TODAY_EVENT"];
            let params = {};

            if (sportCategory == "SOCCER") {
                if (groupId != -1) {
                    apiUrl = apiUrl.replaceAll("eng.1", groupId);
                }
            } else {
                if (groupId != -1) {
                    params = { groups: groupId };
                }
            }

            axios
                .get(apiUrl, {
                    params,
                })
                .then((response) => {
                    setEvents(response.data.events);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [sportCategory, groupId]);

    useEffect(() => {
        let apiUrl = URL[sportCategory];
        if (eventId != -1) {
            axios
                .get(apiUrl, {
                    params: {
                        event: eventId,
                    },
                })
                .then((response) => {
                    setPlayList(response.data);
                });
        }
    }, [eventId]);

    useEffect(() => {
        if (playList?.boxscore?.teams && playList.boxscore.teams[team1Idx]) {
            console.log(playList, "playList");
            const primary_col = playList.boxscore.teams[team1Idx].team.color;
            const secondary_col =
                playList.boxscore.teams[team1Idx].team.alternateColor;

            console.log(primary_col, secondary_col, "color");

            if (primary_col) {
                setPrimaryColor(
                    primary_col.includes("#") ? primary_col : `#${primary_col}`
                );
            }

            if (secondary_col) {
                setSecondaryColor(
                    secondary_col.includes("#")
                        ? secondary_col
                        : `#${secondary_col}`
                );
            }
        }
    }, [playList, team1Idx]);

    const handleEventId = (item) => {
        setEvent(item);
        setEventId(item.id);
        setTeam1Idx(-1);
        setPlayList({});
        setEventDate(item.date);
        console.log(item.status.type.completed, "event status");
    };

    const handleTeam = (index) => {
        setTeam1Idx(index);
    };

    const selectSport = (sport) => {
        setSportCategory(sport);
        setGroupId(-1);
    };

    const handleJoin = () => {
        navigate("/register");
    };

    const handlePlayGame = (index) => {
        if (index === 1) {
            if (event?.status?.type?.completed) {
                toast("This game is over.");
                return;
            }
        }

        if (eventId == -1) {
            toast("Please select game");
            return;
        }

        if (team1Idx == -1) {
            toast("Please select team");
            return;
        }

        if (isDemo && index === 1) {
            setModalIsOpen(true);
            return;
        }

        const gameData = {
            sportCategory,
            eventId,
            team1Idx,
            eventDate,
            startPos: index === 1 ? getRandomNumber() : 0,
            playList,
            primaryColor,
            secondaryColor,
            editPrimaryTeam: index !== 1,
            isFree: index !== 1,
            payout: index === 2 ? 1 : undefined, // Only for fun mode
        };

        if (isDemo && index === 2) {
            dispatch({ type: SPORT_ADD, payload: gameData });
            navigate("/play", { state: gameData });
            return;
        }

        if (index === 1) {
            dispatch({ type: SPORT_ADD, payload: gameData });
            navigate("/point/select");
        } else {
            dispatch({ type: SPORT_ADD, payload: gameData });
            navigate("/play", { state: gameData });
        }
    };

    const goBack = () => {
        if (isDemo) navigate("/register");
        else navigate("/");
    };

    return (
        <>
            <Template>
                <div className="screen-2-section">
                    <div className="screen-2-content">
                        <div className="screen-top-part">
                            <div className="logo-part">
                                <a onClick={goBack}>
                                    <img
                                        src={Logo}
                                        alt="logo"
                                        className="img-fluid"
                                    />
                                </a>
                            </div>
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ marginLeft: 35, marginTop: 35 }}>
                                {!isDemo && (
                                    <>
                                        <a href="/activeGames">
                                            <img
                                                src={DollarIcon}
                                                alt="starIcon"
                                                className="pl-1"
                                                style={{
                                                    width: 25,
                                                    height: 25,
                                                    marginTop: -6,
                                                    marginRight: 10,
                                                }}
                                            />
                                        </a>
                                    </>
                                )}
                                <div className="d-inline-block">
                                    <span className="screen-title d-inline-block">
                                        Pick a Sport
                                    </span>
                                </div>
                                {!isDemo && (
                                    <div className="d-inline-block">
                                        <a href="/savedGames">
                                            <span
                                                style={{
                                                    color: "#fff",
                                                    borderColor: "#fff",
                                                    border: "1px solid",
                                                    padding: "1px 4px",
                                                    borderRadius: 6,
                                                    marginLeft: 14,
                                                    fontSize: 15,
                                                }}>
                                                SAVED
                                            </span>
                                        </a>
                                    </div>
                                )}
                            </div>
                            <div className="sport-list">
                                <ul
                                    className="pb-2"
                                    style={{ overflow: "auto", width: 370 }}>
                                    {SPORTS_CATEGORY.map((item, key) => {
                                        return (
                                            <li
                                                key={key}
                                                onClick={() =>
                                                    selectSport(item.value)
                                                }>
                                                <Link
                                                    className={
                                                        sportCategory ==
                                                            item.value
                                                            ? "selected-category-link"
                                                            : undefined
                                                    }>
                                                    {item.label}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div className="screen-2-centerpart">
                            <span className="screen-purple-glow-title">
                                Pick a Game
                            </span>
                            {(sportCategory == "NCAAFB" ||
                                sportCategory == "NCAABB2" ||
                                sportCategory == "SOCCER" ||
                                sportCategory == "NCAAFB2" ||
                                sportCategory == "NCAABB_NEW") && (
                                <Form.Select
                                    onChange={(e) => {
                                        setGroupId(e.target.value);
                                    }}
                                    size="sm"
                                    className="mt-3">
                                    <option value={-1}>All</option>
                                    {
                                        {
                                            NCAAFB: NCAAFB_GROUP.map(
                                                (item, idx) => {
                                                    return (
                                                        <option
                                                            key={idx}
                                                            value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    );
                                                }
                                            ),
                                            NCAAFB2: NCAAFB_GROUP.map(
                                                (item, idx) => {
                                                    return (
                                                        <option
                                                            key={idx}
                                                            value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    );
                                                }
                                            ),
                                            NCAABB2: NCAABB_GROUP.map(
                                                (item, idx) => {
                                                    return (
                                                        <option
                                                            key={idx}
                                                            value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    );
                                                }
                                            ),
                                            NCAABB_NEW: NCAABB_GROUP.map(
                                                (item, idx) => {
                                                    return (
                                                        <option
                                                            key={idx}
                                                            value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    );
                                                }
                                            ),
                                            SOCCER: SOCCER_GROUP.map(
                                                (item, idx) => {
                                                    return (
                                                        <option
                                                            key={idx}
                                                            value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    );
                                                }
                                            ),
                                        }[sportCategory]
                                    }
                                </Form.Select>
                            )}
                            <div className="screen-2-center-block">
                                <Row>
                                    {events.map((item, index) => (
                                        <Col
                                            xs={6}
                                            key={index}
                                            aria-disabled="true">
                                            <div
                                                className={`screen-2-center-detail ${
                                                    eventId === item?.id
                                                        ? "selected"
                                                        : ""
                                                }`}
                                                onClick={() =>
                                                    handleEventId(item)
                                                }>
                                                <div
                                                    style={{
                                                        opacity: item?.status
                                                            ?.type?.completed
                                                            ? 0.2
                                                            : 1,
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}>
                                                    <img
                                                        src={
                                                            item?.competitions &&
                                                            item
                                                                ?.competitions[0]
                                                                ?.competitors[1]
                                                                ?.team.logo
                                                        }
                                                        alt="team 1"
                                                        className="img-fluid"
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                        }}
                                                    />
                                                    <span>
                                                        vs
                                                        <br />
                                                        <h6
                                                            className="text-warning"
                                                            style={{
                                                                fontSize: 12,
                                                            }}>
                                                            {moment(
                                                                item?.date
                                                            ).format(
                                                                "M/DD h:mm A"
                                                            )}
                                                        </h6>
                                                    </span>
                                                    <img
                                                        src={
                                                            item?.competitions &&
                                                            item
                                                                ?.competitions[0]
                                                                ?.competitors[0]
                                                                ?.team?.logo
                                                        }
                                                        alt="team 2"
                                                        className="img-fluid"
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        </div>
                        <div className="screen-2-bottom-part">
                            <span className="screen-purple-glow-title">
                                Pick a Team
                            </span>
                            <div className="screen-2-bottom-block">
                                <div
                                    className={`screen-2-bottom-name-block ${
                                        team1Idx === 0 ? "selected" : ""
                                    }`}
                                    onClick={() => handleTeam(0)}>
                                    <div className="screen-2-team-name">
                                        {playList?.boxscore ? (
                                            <img
                                                src={
                                                    playList?.boxscore?.teams[0]
                                                        ?.team?.logo
                                                }
                                                alt={
                                                    playList?.boxscore &&
                                                    playList?.boxscore?.teams[0]
                                                        ?.team?.shortDisplayName
                                                }
                                                style={{
                                                    width: 60,
                                                    height: 60,
                                                }}
                                            />
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                    <span className="screen-2-team-name-title">
                                        {playList?.boxscore &&
                                            playList.boxscore.teams[0].team
                                                .shortDisplayName}
                                    </span>
                                </div>
                                <span className="screen-2-opposite-title">
                                    vs
                                </span>
                                <div
                                    className={`screen-2-bottom-name-block ${
                                        team1Idx === 1 ? "selected" : ""
                                    }`}
                                    onClick={() => handleTeam(1)}>
                                    <div className="screen-2-team-name">
                                        {playList?.boxscore ? (
                                            <img
                                                src={
                                                    playList?.boxscore?.teams[1]
                                                        ?.team.logo
                                                }
                                                alt={
                                                    playList?.boxscore &&
                                                    playList?.boxscore?.teams[1]
                                                        ?.team?.shortDisplayName
                                                }
                                                style={{
                                                    width: 60,
                                                    height: 60,
                                                }}
                                            />
                                        ) : (
                                            <div></div>
                                        )}
                                    </div>
                                    <span className="screen-2-team-name-title">
                                        {playList?.boxscore &&
                                            playList?.boxscore?.teams[1]?.team
                                                ?.shortDisplayName}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="screen-2-bottom-button">
                            <Button
                                onClick={() => handlePlayGame(1)}
                                disabled={event?.status?.type?.completed}>
                                <img
                                    src={MoneyWaveIcon}
                                    alt="moneywave"
                                    className="img-fluid"
                                />
                                Play For Money
                            </Button>
                            <Button onClick={() => handlePlayGame(2)}>
                                Play For Fun
                            </Button>
                        </div>
                    </div>
                </div>
                <CustomModal
                    modalIsOpen={modalIsOpen}
                    primaryColor={primaryColor}
                    setModalIsOpen={setModalIsOpen}
                    onRequestClose={() => setModalIsOpen(false)}
                    backgroundColor="#FDDA2F">
                    <div className="mx-4 text-center">
                        <h3>Create A BallHog account to play for money</h3>

                        <Button className="mt-4" onClick={handleJoin}>
                            JOIN
                        </Button>
                    </div>
                </CustomModal>
            </Template>
        </>
    );
};

export default Sports;
